/**
 * Check if element is an Iframe.
 */
export function isIframe(input: HTMLIFrameElement | HTMLElement): input is HTMLIFrameElement {
	return input.tagName === 'IFRAME';
}

export function pageInIframe(window: Window): boolean {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

export class Document {
	static getFirstElementChild(element: Element): Element | null {
		return element.firstElementChild;
	}
}
